var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";

var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var youTubeIframeAPIReady = false;
function onYouTubeIframeAPIReady() {
    youTubeIframeAPIReady = true;
}



function ThumbnailController(params) {
    if(!params) {
        return;
    }
    
    this.setDefaults(params);
    this.addListeners();
    this.fixCoverFit();
}

ThumbnailController.prototype.setDefaults = function(params) {
    this.player = null;
    this.dom = {
        $parent: $(params.parent).first(),
        $frame: $('div' + params.item),
        $thumbnail: $('img' + params.item),
        $trigger: $('button' + params.trigger)
    }
}

ThumbnailController.prototype.fixCoverFit = function(params) {
    if (!Modernizr.objectfit) {
        this.dom.$parent.each(function () {
          var $container = $(this),
              imgUrl = $container.find('img').prop('src');
          if (imgUrl) {
            $container
              .css('backgroundImage', 'url(' + imgUrl + ')')
              .addClass('compat-object-fit');
          }  
        });
      }
}

ThumbnailController.prototype.addListeners = function(params) {
    this.dom.$trigger.on('click touchstart', this.load.bind(this));
}

ThumbnailController.prototype.load = function() {
    if(youTubeIframeAPIReady) {
        var instance = this;
        
        new YT.Player(instance.dom.$frame.attr('id'), {
            videoId: instance.dom.$frame.data('video-id'),
            events: {
                'onReady': function(event) {
                    instance.dom.$trigger.remove();
                    instance.dom.$thumbnail.remove();
                    instance.dom.$frame = instance.dom.$parent.find('iframe');
                    instance.dom.$frame.removeAttr('width').removeAttr('height');
                    instance.player = event.target;
                    instance.player.playVideo();
                }
            }
        });
    }
}

new ThumbnailController({
    parent:  '.wp-content__media',
    item:    '.wp-content__media-item',
    trigger: '.wp-content__media-play'
});

new ThumbnailController({
    parent:  '.wp-become-a-partner__media',
    item:    '.wp-become-a-partner__media-item',
    trigger: '.wp-become-a-partner__media-play'
});

new ThumbnailController({
    parent:  '.wp-gated-content__media',
    item:    '.wp-gated-content__media-item',
    trigger: '.wp-gated-content__media-play'
});